import { render, staticRenderFns } from "./HorizontalTimeline.vue?vue&type=template&id=497d2435&scoped=true&"
import script from "./HorizontalTimeline.vue?vue&type=script&lang=js&"
export * from "./HorizontalTimeline.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTimeline.vue?vue&type=style&index=0&id=497d2435&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497d2435",
  null
  
)

export default component.exports